import { render, staticRenderFns } from "./monedasCambiar.vue?vue&type=template&id=eb5b6f80"
import script from "./monedasCambiar.vue?vue&type=script&lang=js"
export * from "./monedasCambiar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports